<template>
  <div class="flex flex-row">
    <transition appear @before-enter="beforeEnterBox" @enter="enterBox">
      <p data-index="0">
        <i class="copyright outline icon" /> Copyright
        {{ new Date().getFullYear() }} | By
        <span>
          <a :href="portfolio" target="_blank">{{ name }}</a></span
        >
      </p></transition
    >
    <transition-group
      appear
      tag="ul"
      @before-enter="beforeEnterBox"
      @enter="enterBox"
    >
      <li v-for="(media, index) in medias" :key="index" :data-index="index">
        <a :href="media.src" target="_blank">
          <i :class="'icon big ' + media.site" />
        </a>
      </li>
    </transition-group>
  </div>
</template>
<script>
export default {
  props: {
    medias: Array,
    name: String,
    portfolio: String,
    beforeEnterBox: Function,
    enterBox: Function,
  },
};
</script>
